<template>
  <component :is="el" :label="label" :align="align" :prop="prop" :required="required" :error="error">

    <span v-if="noForm && showLabel">{{label}}</span>

    <el-input
      v-if="!disabled"

      :type="type"
      :align="alignInput"
      :size="size"

      v-model="formData"

      :disabled="disabled"
      :pattern="pattern"

      :autosize="type === 'textarea' ? {minRows: 2, maxRows: rows} : null"

      :step="type === 'number' ? (decimals > 0 ? stepValue : '1') : 'any'"

      :rows="rows"

      :placeholder="placeholder ? placeholder : label"
      @focus="$emit('focus')"
      @blur="$emit('blur')"
      @change="updated">

       <!-- eslint-disable-next-line vue/no-v-html -- developer-supplied prefix string from parent; not user-content -->
       <template v-if="prefix" #prepend><i v-if="isPrefixIcon" :class="prefix"></i><span v-else v-html="prefix"></span></template>
       <!-- eslint-disable-next-line vue/no-v-html -- developer-supplied suffix string from parent; not user-content -->
       <template v-if="suffix" #append><i v-if="isSuffixIcon" :class="suffix"></i><span v-else v-html="suffix"></span></template>
       <template #append><el-button v-if="appendIconButton" :on-icon-click="onButtonClick" :icon="appendIconButton"></el-button></template>

    </el-input>

    <span v-else>
      <!-- eslint-disable-next-line vue/no-v-html -- developer-supplied prefix string from parent; not user-content -->
      <span v-if="prefix"><i v-if="isPrefixIcon" :class="prefix"></i><span v-else v-html="prefix"></span></span>
      <b v-if="type === 'number'">{{this.formatNumber(this.formData, this.decimals)}}</b>
      <b v-else v-safe-html="formData" />
      <!-- eslint-disable-next-line vue/no-v-html -- developer-supplied suffix string from parent; not user-content -->
      <span v-if="suffix"><i v-if="isSuffixIcon" :class="suffix"></i><span v-else v-html="suffix"></span></span>
    </span><!-- XOL-596: optional trailing slot INSIDE the form item (the request drawer's "changed underneath you" cue); nothing renders when unused. No whitespace before it, so the unused markup is unchanged. --><slot name="cue"></slot>

  </component>
</template>

<script>

import NumberMixins from '@/mixins/NumberMixins'

export default {
  name: 'text-input',
  mixins: [NumberMixins],

  props: {
    label: {
      type: String,
      default: ''
    },

    showLabel: {
      type: Boolean,
      default: true
    },

    value: {
      required: true
    },

    type: {
      type: String,
      default: 'text'
    },

    size: {
      type: String,
      default: 'default'
    },

    pattern: {
      type: String,
      default: null
    },

    decimals: {
      type: Number,
      default: null
    },

    disabled: {
      type: Boolean,
      default: false
    },

    required: {
      type: Boolean,
      default: false
    },

    prefix: {
      type: String,
      default: null
    },

    rows: {
      type: Number,
      default: 4
    },

    suffix: {
      type: String,
      default: null
    },

    isPrefixIcon: {
      type: Boolean,
      default: false
    },

    isSuffixIcon: {
      type: Boolean,
      default: false
    },

    appendIconButton: {
      type: String,
      default: null
    },

    onButtonClick: {
      type: Function,
      default: null
    },

    placeholder: {
      type: String,
      default: null
    },

    align: {
      type: String,
      default: null
    },

    alignInput: {
      type: String,
      default: 'left'
    },

    helpText: {
      type: String,
      default: null
    },

    prop: {
      type: String,
      default: null
    },

    noForm: {
      type: Boolean,
      default: false
    },

    // XOL-487: additive — el-form-item's plain `error` String prop, a display
    // watcher independent of :model/:rules/validate(). default: null (not
    // '') so Vue omits the attribute entirely when `el` renders as a bare
    // div in no-form mode. Inert for every other call site.
    error: {
      type: String,
      default: null
    }
  },



  methods: {
    updated (value) {
      this.$emit('input', value)
      this.$emit('change', value)
    }

  },


  computed: {
    stepValue: function () {
      if (this.decimals) {

        let s = '0.'
        for (let i = 1; i < this.decimals; i++) {
          s += '0'
        }

        s += '1'

        return Number(s)

      } else {
        return this.step
      }
    }
  },


  watch: {
    value: function (val) {
      this.formData = val
    }
  },


  data () {
    return {
      el: this.noForm ? 'div' : 'el-form-item',
      formData: this.value
    }
  }

}
</script>

<style scoped>
.el-input {
  width: 100%
}
</style>
